<template>
  <div class="home" v-bind:style="bgc">
    <br />
    <b-container fluid>
      <b-row class="text-center">
        <b-col>
          <b-form-select
            @change="filterRestaurants([ratingSelected, priceSelected, distanceSelected])"
            v-model="ratingSelected"
            :options="ratings"
          ></b-form-select>
        </b-col>
        <b-col>
          <b-form-select
            @change="filterRestaurants([ratingSelected, priceSelected, distanceSelected])"
            v-model="priceSelected"
            :options="prices"
          ></b-form-select>
        </b-col>
        <b-col>
          <b-form-select
            @change="filterRestaurants([ratingSelected, priceSelected, distanceSelected])"
            v-model="distanceSelected"
            :options="distance"
          ></b-form-select>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-input
            v-model="searchTerm"
            @change="setSearchTerm(searchTerm)"
            placeholder="Search..."
          ></b-form-input>
        </b-col>
        <b-col cols="5" sm="auto">
          <b-button @click="getYelp" variant="primary">List Resturaunts</b-button>
        </b-col>
      </b-row>
      <br />
      <b-row v-if="showChecklist" class="text-center">
        <b-form-group label="Pick some restaurants you like to make a poll: ">
          <transition-group name="fade">
            <b-form-checkbox
              class="b-checkbox"
              v-for="option in filteredRestaurants"
              v-model="selected"
              :key="option.id"
              :value="option"
              name="rest-check"
              button
              button-variant="light"
              @change="setRestaurantsSelected(selected)"
            >
              {{ option.name }}
              <br />
              <b-img class="b-image" v-bind:src="option.image_url" rounded></b-img>
            </b-form-checkbox>
          </transition-group>
        </b-form-group>
      </b-row>
      <b-row v-if="showChecklist" class="text-center">
        <b-col>
          <b-button @click="createPoll" variant="primary">Make Poll</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
//import ResturauntList from "@/components/RestaurantList";

export default {
  name: "home",
  components: {},
  data() {
    return {
      latitude: 0,
      longitude: 0,
      selected: [],
      ratingSelected: null,
      priceSelected: null,
      distanceSelected: null,
      searchTerm: "",
      ratings: [
        { text: "Rating", value: null },
        { text: "★☆☆☆☆", value: "1" },
        { text: "★★☆☆☆", value: "2" },
        { text: "★★★☆☆", value: "3" },
        { text: "★★★★☆", value: "4" },
        { text: "★★★★★", value: "5" }
      ],
      prices: [
        { text: "Price", value: null },
        { text: "$", value: "$" },
        { text: "$$", value: "$$" },
        { text: "$$$", value: "$$$" },
        { text: "$$$$", value: "$$$$" }
      ],
      distance: [
        { text: "Distance", value: null },
        { text: "5 mi", value: "5" },
        { text: "10 mi", value: "10" },
        { text: "15 mi", value: "15" },
        { text: "20 mi", value: "20" }
      ],
      bgc: {
        backgroundImage: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "allRestaurants",
      "filteredRestaurants",
      "getPollID",
      "showChecklist"
    ])
  },
  methods: {
    ...mapActions(["fetchRestaurants", "filterRestaurants", "sendPollData"]),
    ...mapMutations(["setRestaurantsSelected", "setSearchTerm"]),
    getYelp() {
      this.selected = [];
      navigator.geolocation.getCurrentPosition(
        this.showLocation,
        this.locationError
      );
      this.fetchRestaurants([
        this.ratingSelected,
        this.priceSelected,
        this.distanceSelected,
        this.latitude,
        this.longitude
      ]);
    },
    showLocation(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
    },
    locationError() {
      alert("LOCATION ERROR");
    },
    createPoll() {
      if (this.selected.length > 0) {
        this.sendPollData(this.selected);
        this.$router.push("/poll/" + this.getPollID);
      }
      //console.log(this.getPollID);
    }
  },
  created() {
    navigator.geolocation.getCurrentPosition(
      this.showLocation,
      this.locationError,
      { timeout: 10000 }
    );
  }
};
</script>

<style scoped>
</style>
